import { cn as mergeClassNames, type ClassValue } from 'cn';

/**
 * Combines class names with Tailwind CSS class merging.
 * shadcn-ui/cn joins (clsx) and resolves conflicts (tailwind-merge) in one pass,
 * so we call it directly rather than `twMerge(clsx(...))`.
 * @param inputs - Class names to combine
 */
export function cn(...inputs: ClassValue[]) {
  return mergeClassNames(...inputs);
}
